<template>
  <div class="WX-78">
    <ol>
      <li>
        <div>자갈길 지형에 널려있는 상자 속에서 배를 운행할 아이템을 수집하세요</div>
        <div>유목노 / 닻 / 키 / 돛 / 말바트로스 돛 / 배 수리키트</div>
      </li>
      <li>
        <div>조각난 달 섬에서 파인 월석을 챙기세요</div>
        <div>반드시 하나만 가져올것</div>
      </li>
      <li>
        <div>경유지에서 자신의 보석을 찾아 파인 월석에 끼우세요</div>
      </li>
      <li>
        <div>모든 미션을 완료하고 가장 먼저 도착하는 사람이 승리합니다</div>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'WX-78'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/Boat.vue